import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useMeetingTypesPath } from 'hooks/use_meeting_types_path';
import calendlyWordmark from '../../../images/logos/calendly-wordmark.svg';
import calendlyLogo from '../../../images/logos/calendly.svg';
const logoButtonMinimizedCss = "l1sidlds";

/** Phone-only: logo button width unset (e.g. in detached trigger bar). */
const logoButtonMobileCss = "l1eu70fp";
const logoButtonCss = "l1g65343";
const LogoButton = forwardRef((props, ref) => {
  const {
    minimized,
    isPhone,
    ...restProps
  } = props;
  return <BareButton ref={ref} {...restProps} className={classNames(logoButtonCss, {
    [logoButtonMinimizedCss]: minimized,
    [logoButtonMobileCss]: isPhone
  }, props.className)} />;
});
const calendlyIconCss = "c1vrj5b6";
const CalendlyIcon = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'img';
  const src = calendlyLogo;
  return <Component ref={ref} {...restProps} src={src} aria-hidden className={classNames(calendlyIconCss, props.className)} />;
});
const calendlyWordingCss = "c1n7djry";
const CalendlyWording = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'img';
  const src = calendlyWordmark;
  const alt = 'Calendly';
  return <Component ref={ref} {...restProps} src={src} alt={alt} className={classNames(calendlyWordingCss, props.className)} />;
});

/**
 * @param {Object} props
 * @param {boolean} [props.minimized] - When true, show only the "C" icon and keep it left-aligned.
 * @param {boolean} [props.isPhone] - When true, apply phone-only styles (e.g. width: 0 in detached trigger bar).
 */
export const CalendlyLogo = ({
  minimized,
  isPhone
}) => <LogoButton as="a" aria-label={I18n.t('publisher.menu.home')} href={useMeetingTypesPath()} minimized={minimized} isPhone={isPhone}>
    <CalendlyIcon />
    {!minimized && <CalendlyWording />}
  </LogoButton>;

require("./calendly_logo.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./calendly_logo.js");